import { useMutation, useQueryClient } from '@tanstack/react-query';

import { session } from '@/shared/session/session';

import { authApi } from '../api/auth-api';

/** Accepting sets the session cookie, so /me is refreshed exactly like after a login. */
export function useAcceptInvitation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: authApi.acceptInvitation,
    meta: { silentError: true },
    onSuccess: () => session.refreshSession(queryClient),
  });
}
